import React, { useContext, useEffect, useState } from 'react';
import { SmallMatchBox } from '../smallMatchBox';
import { ConnectionContext, displayLoader, displayErrorMessage, getEndpoint, shuffle } from '../../utils';
import { getStoredData } from '../../utils/data-pulls';


/**
 * Match Info Widget:
 * Competition, Venue, and Attendance
 */
const UpcomingGamesWidget = (props) => {
    const { 
        type = 'all',
        team = null,
        competition = null,
        ...restProps 
    } = props;

    const connectionInfo = useContext(ConnectionContext);

    const [competitions, setCompetitions] = useState(false);

    // Error and load handling
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    const [matches, setMatches] = useState(null);


    /**
     * Get upcoming games
     */
    useEffect(() => {
        if ( !connectionInfo ) return;

        let upcomingMatchesArgs = {
            key: 'upcomingMatches',
            type: type,
            number: 2
        };

        switch (type) {
            case 'competition':
                upcomingMatchesArgs.id = competition;
                break;
            case 'team':
                upcomingMatchesArgs.id = team;
                break;
            default:
                break;
        }

        // Get matches list
        let args = [upcomingMatchesArgs];

        getStoredData(args).then(
            (result) => {

                // Set Matches
                if ( result.data.upcomingMatches ) {
                    setMatches(result.data.upcomingMatches);
                }
                setIsLoaded(true);

            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

    }, [connectionInfo]);


     // Bail if we don't have data yet
     if (!isLoaded ) {
        return displayLoader();
    }

    // Display an error message if there's a problem
    if ( error ) {
        console.log(error);
        return displayErrorMessage();
    }

    return (
        <div className="acaWidget acaWidget--liveGames">

            <div className="acaWidget__header">
                <div className="acaWidget__headerMain">
                    <h4 className="acaH4 acaWidget__title">Upcoming Games</h4>
                </div>
            </div>
            
            <div className="acaWidget__inner">
                { !matches ? (
                    <>
                        {displayErrorMessage('There are no upcoming games.', 'acaError--simple')}
                        { acaScheduleURL ? (
                            <a href={acaScheduleURL} className="acaBtn acaBtn--solid acaBtn--black acaBtn--calendarIcon">See Game Schedule</a>
                        ) : '' }
                    </>
                ) : (
                    <>
                        { matches.map((row, i) => (
                            <SmallMatchBox key={i} data={row} />
                        )) }
                        { acaScheduleURL ? (
                            <a href={acaScheduleURL} className="acaBtn acaBtn--solid acaBtn--black acaBtn--calendarIcon">See Game Schedule</a>
                        ) : '' }
                    </>
                ) }
            </div>

        </div>
    );
}





/**
 * Export
 */
export { UpcomingGamesWidget };

